export default __webpack_public_path__ + "static/media/one.f912b9ac.png";